// extracted by mini-css-extract-plugin
export default {"root":"IconView_root__i6cvW"};